import { TeamAbrvID } from '@shared/types';

export const TeamRivalries: Record<TeamAbrvID, TeamAbrvID[]> = {
  ['01-ARI']: ['06-CHI', '19-LAR', '28-SF', '29-SEA'],
  ['02-ATL']: ['05-CAR', '30-TB', '23-NO'],
  ['03-BAL']: ['07-CIN', '08-CLE', '22-NE', '26-PIT', '31-TEN', '32-WSH'],
  ['04-BUF']: ['16-KC', '20-MIA', '22-NE', '25-NYJ', '31-TEN'],
  ['05-CAR']: ['02-ATL', '23-NO', '30-TB'],
  ['06-CHI']: ['01-ARI', '11-DET', '12-GB', '21-MIN', '24-NYG'],
  ['07-CIN']: ['03-BAL', '08-CLE', '26-PIT'],
  ['08-CLE']: ['03-BAL', '07-CIN', '26-PIT'],
  ['09-DAL']: ['12-GB', '13-HOU', '21-MIN', '24-NYG', '26-PIT', '27-PHI', '28-SF', '32-WSH'],
  ['10-DEN']: ['16-KC', '17-LV', '18-LAC', '22-NE', '29-SEA'],
  ['11-DET']: ['06-CHI', '12-GB', '21-MIN'],
  ['12-GB']: ['06-CHI', '09-DAL', '11-DET', '21-MIN', '28-SF', '29-SEA', '30-TB'],
  ['13-HOU']: ['09-DAL', '14-IND', '15-JAX', '31-TEN'],
  ['14-IND']: ['13-HOU', '15-JAX', '22-NE', '31-TEN'],
  ['15-JAX']: ['13-HOU', '14-IND', '31-TEN'],
  ['16-KC']: ['04-BUF', '10-DEN', '17-LV', '18-LAC', '19-LAR'],
  ['17-LV']: ['10-DEN', '16-KC', '20-MIA', '26-PIT', '28-SF', '29-SEA'],
  ['18-LAC']: ['10-DEN', '16-KC', '19-LAR'],
  ['19-LAR']: ['01-ARI', '16-KC', '18-LAC', '21-MIN', '23-NO', '28-SF', '29-SEA'],
  ['20-MIA']: ['04-BUF', '17-LV', '22-NE', '25-NYJ', '30-TB'],
  ['21-MIN']: ['06-CHI', '09-DAL', '11-DET', '12-GB', '19-LAR'],
  ['22-NE']: ['03-BAL', '04-BUF', '10-DEN', '14-IND', '20-MIA', '24-NYG', '25-NYJ', '26-PIT'],
  ['23-NO']: ['02-ATL', '05-CAR', '19-LAR', '30-TB'],
  ['24-NYG']: ['06-CHI', '09-DAL', '22-NE', '25-NYJ', '27-PHI', '28-SF', '32-WSH'],
  ['25-NYJ']: ['04-BUF', '20-MIA', '22-NE', '24-NYG'],
  ['26-PIT']: ['03-BAL', '07-CIN', '08-CLE', '09-DAL', '17-LV', '22-NE', '27-PHI', '31-TEN'],
  ['27-PHI']: ['09-DAL', '24-NYG', '26-PIT', '32-WSH'],
  ['28-SF']: ['01-ARI', '09-DAL', '12-GB', '17-LV', '19-LAR', '24-NYG', '29-SEA'],
  ['29-SEA']: ['01-ARI', '10-DEN', '12-GB', '17-LV', '19-LAR', '28-SF'],
  ['30-TB']: ['02-ATL', '05-CAR', '12-GB', '20-MIA', '23-NO'],
  ['31-TEN']: ['03-BAL', '04-BUF', '13-HOU', '14-IND', '15-JAX', '26-PIT'],
  ['32-WSH']: ['09-DAL', '03-BAL', '24-NYG', '27-PHI'],
};

// Battle of the Bay: 28-SF vs. 17-LV
// Texas Governor's Cup: 09-DAL vs. 13-HOU
// The Battle of Los Angeles: 19-LAR vs. 18-LAC
// Beltway Bowl: 32-WSH vs. 03-BAL
